import { render } from "./invalid.vue?vue&type=template&id=5c8d5fbe&scoped=true"
import script from "./invalid.vue?vue&type=script&lang=ts"
export * from "./invalid.vue?vue&type=script&lang=ts"

import "./invalid.vue?vue&type=style&index=0&id=5c8d5fbe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c8d5fbe"

export default script